<template>
  <div class="sn-page sn-assembly record-cancel">
    <sn-popup :title="title" @sendBack="sendBack">
      <div class="reason">
        <div class="sn-f-s-c sn-pointer reason-line" :class="{'sn-fc-main': caption === selectedCaption}"
        :key="i" v-for="(caption, i) in captionInfo" @click="selectedCaption = caption;">
          <div class="iconfont" :class="{
            'icon-fangkuangweixuanzhong': caption !== selectedCaption,
            'icon-a-jianqu5 sn-fc-main': caption === selectedCaption
          }"></div>
          <div>{{ reasonInfo[caption] || title }}</div>
        </div>
        <div class="sn-f-e-c">
          <div class="sn-f-c-c sn-pointer reason-interaction" @click="goCancel();">{{ $sn.format.getQuality(this.record, 'params.type') === '1' ? '确认退款' : '确认取消' }}</div>
        </div>
      </div>
    </sn-popup>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  name: 'record-cancel',
  mixins: [AppointmentMixin],
  props: {
    record: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: '',
      reasonInfo: {},
      selectedCaption: '',
      captionInfo: self.$sn.getConfig('recordCancelReason')
    };
  },
  mounted() {
    this.$nextTick(() => {});
  },
  created: function() {
    this.title = this.$sn.format.caption(Messages.APPOINT008, [this.$sn.format.getQuality(this.record, 'params.type') === '1' ? '退款' : '取消' + this.appointmentContent]);
    this.$sn.utils.ordinaryRequest({
      domain: 'static',
      url: '/hos/ui/caption/appointment/reason.js?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
    }).then(result => {
      if (result && this.$sn.validate.object(result)) {
        this.reasonInfo = result;
      }
    });
  },
  methods: {
    goCancel(value) {
      if (this.$sn.validate.empty(this.selectedCaption)) {
        this.$sn.assembly.modal({
          caption: this.title
        });
        return false;
      }
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
        if (this.$sn.validate.empty(value)) {
          this.$sn.assembly.modal({
            title: '温馨提示',
            caption: Messages.APPOINT097,
            captionCancel: '否',
            captionConfirm: '是',
            success: (modal) => {
              if (modal.confirm) {
                this.goCancel('value');
              }
            }
          });
          return false;
        }
      }
      if (this.$sn.validate.empty(value) && !this.$sn.getConfig('isOpenPromptCancalComplete') && this.record.isDopay === 1 && parseFloat(this.record.regFee) > 0) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.APPOINT009, [this.appointmentContent, this.$sn.getConfig('isOpenRobotizationDeduction') ? Messages.APPOINT010 : Messages.APPOINT011]),
          isCancel: false,
          success: (modal) => {
            if (modal.confirm) {
              this.goCancel('value');
            }
          }
        });
        return false;
      }
      const params = {
        url: this.$sn.format.caption(Swagger.cancelAppointment, [this.$sn.utils.getPlatformType(), this.$sn.utils.getHospitalId(), this.$sn.utils.getOpenId(), this.record.appointId]),
        query: {
          projectType: this.$sn.utils.getProjectType(),
          regType: this.$sn.utils.getRegType() || this.perpetual.REG_TYPE_OTHER,
          reason: this.selectedCaption
        },
        method: 'PUT',
        header: true
      };
      params.url = encodeURI(params.url).replace(/\+/g, '%2B');
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (this.$sn.getConfig('isOpenPromptCancalComplete')) {
              this.$sn.assembly.modal({
                caption: this.$sn.format.caption(Messages.APPOINT012, [this.appointmentContent, this.$sn.getConfig('costContentTitle'),
                  !this.$sn.validate.empty(this.record.regFee) && parseFloat(this.record.regFee) > 0 ? this.record.regFee + '元' : '']),
                isCancel: false,
                success: (modal) => {
                  if (modal.confirm) {
                    this.sendBack(true);
                  }
                }
              });
            }
            else {
              this.$sn.assembly.toast({
                caption: this.$sn.format.caption(Messages.C016, [this.$sn.format.getQuality(this.record, 'params.type') === '1' ? '退款' : '取消' + this.appointmentContent]),
                mode: 'success',
                success: () => {
                  this.sendBack(true);
                }
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001
          });
        }
      });
    },
    sendBack(type) {
      this.$emit('sendBack', type);
    }
  }
};
</script>
<style lang="scss" scoped>
.record-cancel {
  z-index: 999;

  .reason {
    overflow: hidden;
    width: 500px;
    padding: 20px;

    &-line {
      @include fs(14);

      overflow: hidden;
      width: 100%;
      color: $text6;
      margin-bottom: 20px;

      .iconfont {
        font-size: 12px;
        color: $text6;
        margin-right: 5px;
      }
    }

    &-interaction {
      @include fs(14);

      width: 120px;
      height: 40px;
      background-color: $main;
      color: $white;
      border-radius: 5px;
    }
  }
}
</style>
